
import Accordion from './Accordion';
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import GoogleAnalytics from '../components/GoogleAnalytics';



function Punetomumbaicab() {



  const cardData =
  {
    keyword: ' Pune to Mumbai Cab',
    heading: 'SHREE Tours & Travels: Pune to Mumbai Cab',
    headingDescription: 'SHREE Tours & Travels provides a reliable Pune to Mumbai Cab service, ensuring a comfortable and hassle-free journey. Whether you are traveling for business, leisure, or catching a flight, our well-maintained Cabs and professional drivers offer a smooth ride. Enjoy a safe and convenient trip with flexible booking options and competitive fares. Choose SHREE Tours & Travels for a stress-free Pune to Mumbai travel experience.',

    top: 'Top Places to Visit in Mumbai with SHREE Tours & Travels',

"topPlaces": [
    {
        "title": "Gateway of India",
        "description": "An iconic landmark of Mumbai, the Gateway of India is a grand arch overlooking the Arabian Sea. Built in 1924, it is a historical and architectural marvel that attracts tourists and serves as a starting point for ferry rides to Elephanta Caves."
    },
    {
        "title": "Marine Drive",
        "description": "A picturesque boulevard along the coastline, Marine Drive is known for its stunning sunset views and the famous 'Queen’s Necklace' effect at night. It's a popular spot for locals and tourists to unwind, take leisurely strolls and enjoy street food."
    },
    {
        "title": "Chhatrapati Shivaji Maharaj Terminus",
        "description": "A UNESCO World Heritage Site, this historic railway station is a stunning example of Victorian Gothic architecture. It is not only a functional hub but also an architectural masterpiece showcasing intricate carvings and grand design."
    },
    {
        "title": "Elephanta Caves",
        "description": "Located on Elephanta Island, these ancient rock-cut caves house impressive sculptures of Lord Shiva. A UNESCO World Heritage Site, the caves are a must-visit for history and art lovers, accessible via a ferry ride from the Gateway of India."
    },
    {
        "title": "Siddhivinayak Temple",
        "description": "One of Mumbai’s most revered temples, Siddhivinayak Temple is dedicated to Lord Ganesha. Devotees from across the country visit to seek blessings, including celebrities and dignitaries."
    },
    {
        "title": "Juhu Beach",
        "description": "Famous for its lively atmosphere and Mumbai’s signature street food, Juhu Beach is a favorite hangout spot. Visitors can enjoy the ocean breeze, horse rides and a variety of snacks like pav bhaji and vada pav."
    },
    {
        "title": "Bandra-Worli Sea Link",
        "description": "A marvel of modern engineering, the Bandra-Worli Sea Link connects the suburbs to South Mumbai. This Cable-stayed bridge offers breathtaking views of the city skyline and the Arabian Sea."
    },
    {
        "title": "Haji Ali Dargah",
        "description": "Situated on an islet in the Arabian Sea, Haji Ali Dargah is a revered Muslim shrine visited by people of all faiths. The stunning Indo-Islamic architecture and the serene surroundings make it a peaceful spiritual retreat."
    },
    {
        "title": "Chor Bazaar",
        "description": "One of the oldest flea markets in Mumbai, Chor Bazaar is a treasure trove for antique lovers and bargain hunters. From vintage collectibles to second-hand goods, this market offers a unique shopping experience."
    },
    {
        "title": "Film City",
        "description": "Mumbai, the heart of Bollywood, is home to the famous Film City. Visitors can explore the sets of popular movies, witness live shooting and experience the magic of Indian cinema."
    }
],  
    
            
"services": [
    {
      "name": "Pune to Mumbai Taxi",
      "description": "Travel comfortably with SHREE Tours & Travels by booking a taxi from Pune to Mumbai. Our well-maintained fleet, including sedans, SUVs and luxury cars, along with our professional drivers, ensure a smooth and hassle-free journey at competitive rates. Enjoy a stress-free experience with flexible pick-up and drop-off options tailored to your schedule."
    },
    {
      "name": "Pune to Mumbai Cab Booking",
      "description": "Looking for a reliable and convenient Cab service from Pune to Mumbai? We offer a variety of options, including one-way and round-trip bookings, at affordable prices. Our fleet includes comfortable and spacious vehicles with experienced drivers, ensuring your travel is safe, timely and hassle-free. Book your Cab online or via phone with ease."
    },
    {
      "name": "Pune to Mumbai One-Way Cab",
      "description": "Need a one-way taxi from Pune to Mumbai? SHREE Tours & Travels provides an affordable, stress-free one-way travel option. Whether you’re traveling for business or leisure, enjoy a comfortable, timely ride without hidden charges. Our drivers are experienced and knowledgeable, ensuring a smooth journey from start to finish."
    },
    {
      "name": "Pune to Mumbai Round Trip Taxi",
      "description": "Planning a round-trip to Mumbai? Our round-trip taxi service provides flexibility for travelers, whether you're returning on the same day or after a few days. We offer competitive pricing and well-maintained vehicles, ensuring you travel in comfort and style, with professional drivers who know the best routes for a faster, safer journey."
    },
    {
      "name": "Affordable Pune to Mumbai Cab",
      "description": "Get budget-friendly Cab services from Pune to Mumbai with SHREE Tours & Travels, without compromising on comfort or reliability. We offer competitive rates on one-way and round-trip services, ensuring you get the best value for your money. Our experienced drivers and well-maintained fleet guarantee a smooth ride at an affordable price."
    },
    {
      "name": "Luxury Pune to Mumbai Cab Service",
      "description": "For a premium travel experience, choose our luxury Cab service from Pune to Mumbai. Select from high-end vehicles like the Innova Crysta, Kia Carnival, or luxury sedans and enjoy a plush ride with extra legroom, premium amenities and a highly professional chauffeur. Ideal for business trips, family vacations, or special occasions."
    },
    {
      "name": "Private Cab for Mumbai from Pune",
      "description": "Experience personalized travel with our private Cab service from Pune to Mumbai. Enjoy the freedom to travel at your own pace, with your own schedule and in complete privacy. Choose from a range of vehicles that suit your needs, whether it’s for a solo trip, business meeting, or family outing. Our drivers ensure your comfort and safety throughout the journey."
    },
    {
      "name": "Mumbai Travel from Pune by Cab",
      "description": "Planning a tour to Mumbai from Pune? Our Cab service ensures a smooth, comfortable and hassle-free trip. Choose from our flexible travel packages with sightseeing options, where you can explore the best of Mumbai with a professional driver guiding you along the way. From famous landmarks to hidden gems, let us make your trip memorable."
    },
    {
      "name": "Group Travel to Mumbai by Cab",
      "description": "Traveling with a group? We provide spacious and comfortable vehicles like SUVs and tempo travelers to accommodate larger groups. Whether it’s a family trip, corporate outing, or friends’ getaway, we ensure a smooth group travel experience with all the necessary comfort and amenities for an enjoyable journey."
    },
    {
      "name": "Book Pune to Mumbai Car",
      "description": "Rent a car for your Pune to Mumbai journey with SHREE Tours & Travels. Choose from a variety of vehicles such as sedans, SUVs and tempo travelers based on your group size and preferences. Our cars are well-maintained, ensuring a comfortable and hassle-free ride. Book easily online or through our customer support team."
    },
    {
      "name": "Pune to Mumbai Cab Rental",
      "description": "Looking for a car rental service for your Pune to Mumbai trip? SHREE Tours & Travels offers reliable Cab rentals with flexible options. Whether it’s a one-way journey or round-trip, our rentals come with experienced drivers and well-maintained vehicles, ensuring a comfortable and safe journey."
    },
    {
      "name": "Pune to Mumbai Luxury Taxi",
      "description": "For those looking for an upscale travel experience, our Pune to Mumbai luxury taxi service provides premium vehicles like Mercedes and Audi, perfect for corporate travel, special occasions, or those who simply want to indulge in comfort. Enjoy superior service and a smooth ride with our professional drivers ensuring a high standard of service."
    },
    {
      "name": "Pune to Mumbai Budget Taxi",
      "description": "Traveling on a budget? SHREE Tours & Travels offers affordable taxi services from Pune to Mumbai, without compromising on comfort or reliability. Choose from a range of vehicles, including sedans and SUVs, to fit your budget and enjoy a safe and comfortable ride. Enjoy cost-effective travel with our transparent pricing and no hidden charges."
    },
    {
      "name": "Mumbai Trip by Cab",
      "description": "Plan your Mumbai trip with our Cab service for a convenient, comfortable and safe journey. Whether it’s for sightseeing or business, our professional drivers will ensure a smooth, enjoyable ride. We offer a variety of vehicles, ensuring there’s an option for every traveler, from solo trips to large groups."
    },
    {
      "name": "Pune to Mumbai Road Trip",
      "description": "Looking to enjoy a scenic road trip from Pune to Mumbai? Our road trip package offers comfortable vehicles, experienced drivers and a relaxed journey. Take in the sights along the way, stop at interesting points and enjoy a road trip experience like never before. Whether you want to go at a leisurely pace or make quick stops, we’ve got you covered."
    },
    {
      "name": "Pune to Mumbai Taxi for Family",
      "description": "Traveling with family? Our family-friendly taxi service ensures a safe, comfortable and enjoyable journey from Pune to Mumbai. With spacious vehicles like SUVs and MPVs, we ensure there’s enough room for everyone, along with child-friendly amenities and professional drivers who prioritize your family’s comfort and safety."
    },
    {
      "name": "Pune to Mumbai Comfort Cab",
      "description": "Book a comfortable Cab for your Pune to Mumbai journey with SHREE Tours & Travels. We provide well-maintained vehicles, including sedans and SUVs, with air conditioning, ample legroom and a smooth ride. Our professional chauffeurs are trained to offer you a pleasant travel experience from start to finish."
    },
    {
      "name": "Mumbai Sightseeing by Cab",
      "description": "Explore the vibrant city of Mumbai with our sightseeing Cab service. Visit iconic landmarks like the Gateway of India, Marine Drive and Elephanta Caves in the comfort of our well-maintained vehicles, accompanied by an experienced driver who can also act as your local guide. Enjoy a personalized sightseeing tour based on your interests and time."
    }
  ],

  "tableData": [
    ["- Pune to Mumbai Taxi", "- Pune to Mumbai Cab Booking"],
    ["- Pune to Mumbai One-Way Cab", "- Pune to Mumbai Round Trip Taxi"],
    ["- Affordable Pune to Mumbai Cab", "- Luxury Pune to Mumbai Cab Service"],
    ["- Private Cab for Mumbai from Pune", "- Mumbai Travel from Pune by Cab"],
    ["- Group Travel to Mumbai by Cab", "- Book Pune to Mumbai Car"],
    ["- Pune to Mumbai Cab Rental", "- Pune to Mumbai Luxury Taxi"],
    ["- Pune to Mumbai Budget Taxi", "- Mumbai Trip by Cab"],
    ["- Pune to Mumbai Road Trip", "- Pune to Mumbai Taxi for Family"],
    ["- Pune to Mumbai Comfort Cab", "- Mumbai Sightseeing by Cab"]
  ],
  
  whychoose: [
    {
      "WhyChooseheading": "Comfortable Journey",
      "WhyChoosedescription": "Our Pune to Mumbai Cabs are designed to provide a comfortable and relaxing experience. With spacious interiors, comfortable seating and air-conditioning, you can enjoy a smooth ride. Whether you're traveling for business or leisure, our Cabs are perfect for both short and long-distance travel."
    },
    {
      "WhyChooseheading": "Experienced Drivers",
      "WhyChoosedescription": "Our drivers are experienced and well-versed in the Pune to Mumbai route. They ensure a safe and timely journey, following all safety protocols. With their local knowledge, they take the best routes to avoid traffic and ensure a hassle-free ride, so you can relax and enjoy your trip."
    },
    {
      "WhyChooseheading": "Affordable Pricing",
      "WhyChoosedescription": "We offer affordable pricing for your Pune to Mumbai Cab ride, with no hidden fees. Our competitive rates ensure you get great value for money, whether you're booking a one-way ride or a round trip. We believe in transparency, so you can rely on us for fair pricing."
    },
    {
      "WhyChooseheading": "Well-Maintained Vehicles",
      "WhyChoosedescription": "All our vehicles are regularly serviced and maintained to ensure they are in optimal condition. From clean interiors to smooth performance, our cars are kept in top shape to guarantee a comfortable and safe journey. Whether you're traveling alone or with family, you can trust our vehicles for a worry-free ride."
    },
    {
      "WhyChooseheading": "Flexible Rental Options",
      "WhyChoosedescription": "We understand that every traveler has different needs, which is why we offer flexible rental options for your Pune to Mumbai journey. Whether you need a Cab for a few hours or a whole day, we can tailor the rental to your specific requirements and preferences."
    },
    {
      "WhyChooseheading": "Easy Booking Process",
      "WhyChoosedescription": "Booking a Cab for your Pune to Mumbai trip is quick and easy with SHREE Tours & Travels. You can book online via our user-friendly platform or contact our customer service for personalized assistance. We ensure a seamless booking experience for both advanced reservations and last-minute bookings."
    },
    {
      "WhyChooseheading": "24/7 Availability",
      "WhyChoosedescription": "Our Pune to Mumbai Cab services are available 24/7. No matter the time of day or night, we are ready to serve you. Whether you're catching an early morning flight or need a late-night ride, we are always here to accommodate your travel schedule."
    },
    {
      "WhyChooseheading": "Local Insights",
      "WhyChoosedescription": "Our experienced drivers not only know the best routes from Pune to Mumbai but also have extensive knowledge of the local culture and attractions. If you're interested in sightseeing or need recommendations for stops along the way, they are happy to share their insights, making your trip more enjoyable."
    },
    {
      "WhyChooseheading": "Customer Satisfaction Guarantee",
      "WhyChoosedescription": "At SHREE Tours & Travels, customer satisfaction is our priority. We are committed to providing the best service for every ride. With a focus on comfort, punctuality and safety, we ensure your Pune to Mumbai trip is seamless, leaving you with a positive and memorable experience."
    }
  ]
  
  



        
  }

  const faqData = [
    {
        question: "How can I book a Cab from Pune to Mumbai?",
        answer: "You can easily book your Pune to Mumbai Cab through our website or by calling our customer service for assistance."
    },
    {
        question: "What types of Cabs do you offer for the Pune to Mumbai route?",
        answer: "We offer a variety of vehicles for the Pune to Mumbai journey, including sedans, SUVs and MPVs, to suit your preferences and group size."
    },
    {
        question: "Are the rental rates from Pune to Mumbai inclusive of fuel?",
        answer: "Fuel charges may vary depending on the rental agreement. Detailed pricing information will be provided during the booking process."
    },
    {
        question: "Can I book a Cab for a one-way trip from Pune to Mumbai?",
        answer: "Yes, we offer one-way rental options for your Pune to Mumbai trip."
    },
    {
        question: "Do you provide drivers with the rental Cab for the Pune to Mumbai trip?",
        answer: "Yes, all our Cabs come with experienced drivers who are familiar with the route to ensure a safe and comfortable journey."
    },
    {
        question: "What is your cancellation policy for a Pune to Mumbai Cab booking?",
        answer: "We offer a flexible cancellation policy. Please contact us for detailed information specific to your booking."
    },
    {
        question: "What payment methods do you accept for the Pune to Mumbai Cab booking?",
        answer: "We accept various payment methods, including cash, credit/debit cards and mobile wallets for your convenience."
    },
    {
        question: "Are the vehicles insured for the Pune to Mumbai trip?",
        answer: "Yes, all our vehicles come with insurance coverage for your safety while traveling."
    },
    {
        question: "Can I request a child seat for my Cab from Pune to Mumbai?",
        answer: "Yes, child seats can be arranged upon request at the time of booking."
    },
    {
        question: "What is your contact information for booking a Cab from Pune to Mumbai?",
        answer: "For bookings and inquiries, you can reach us at: +91 9594917913."
    }
];

const testimonialsData = [
    {
        text: 'The Pune to Mumbai journey was smooth and comfortable! The driver was very professional and the vehicle was well-maintained.',
        name: 'Mr. Arjun Mehta',
    },
    {
        text: 'I had a great experience with SHREE Tours & Travels for my Pune to Mumbai trip. The driver was courteous and the ride was peaceful.',
        name: 'Miss. Neha Desai',
    }
];




  
  
  


  


  const contactData = {
     heading: `${cardData.keyword} Contact Number`,
    contactNumbers: [
      "+91 9594917913",

    ],
    email: "booking@shreecabs24.com"
  };


    const Images = [
    {
        place: "/images/keyword/1.jpg",
        text: "Pune to Kolhapur Cab",
        link: "/Pune-to-Kolhapur-Cab",
    },
    {
        place: "/images/keyword/2.jpg",
        text: "Pune to Mumbai Cab",
        link: "/Pune-to-Mumbai-Cab",
    },
    {
        place: "/images/keyword/3.jpg",
        text: "Pune to Sangli Cab",
        link: "/Pune-to-Sangli-Cab",
    },
    {
        place: "/images/keyword/4.jpg",
        text: "Pune to Mahabaleshwar Cab",
        link: "/Pune-to-Mahabaleshwar-Cab",
    },
    {
        place: "/images/keyword/5.jpg",
        text: "Pune to Bhimashankar Cab",
        link: "/Pune-to-Bhimashankar-Cab",
    },
    {
        place: "/images/keyword/6.jpg",
        text: "Pune to Shirdi Cab",
        link: "/Pune-to-Shirdi-Cab",
    },
    {
        place: "/images/keyword/7.jpg",
        text: "Pune to Nashik Cab",
        link: "/Pune-to-Nashik-Cab",
    },
    {
        place: "/images/keyword/8.jpg",
        text: "Pune Airport Pickup and Drop",
        link: "/Pune-Airport-Pickup-and-Drop",
    },
    {
        place: "/images/keyword/9.jpg",
        text: "Pune To Mumbai Airport Cab",
        link: "/Pune-To-Mumbai-Airport-Cab",
    },
    {
        place: "/images/keyword/10.jpg",
        text: "Mumbai To Pune Cab",
        link: "/Mumbai-To-Pune-Cab",
    },
    {
        place: "/images/keyword/12.jpg",
        text: "Mumbai To Kolhapur Cab",
        link: "/Mumbai-To-Kolhapur-Cab",
    },
    {
        place: "/images/keyword/13.jpg",
        text: "Mumbai To Shirdi Cab",
        link: "/Mumbai-To-Shirdi-Cab",
    },
    {
        place: "/images/keyword/14.jpg",
        text: "Mumbai To Nashik Cab",
        link: "/Mumbai-To-Nashik-Cab",
    },
    {
        place: "/images/keyword/15.jpg",
        text: "Mumbai Airport To Pune Cab",
        link: "/Mumbai-Airport-To-Pune-Cab",
    },
    {
        place: "/images/keyword/16.jpg",
        text: "Kolhapur To Pune Cab",
        link: "/Kolhapur-To-Pune-Cab",
    },
    {
        place: "/images/keyword/17.jpg",
        text: "Kolhapur To Mumbai Cab",
        link: "/Kolhapur-To-Mumbai-Cab",
    },
    {
        place: "/images/keyword/18.jpg",
        text: "Sangli To Pune Cab",
        link: "/Sangli-To-Pune-Cab",
    },
    {
        place: "/images/keyword/19.jpg",
        text: "One Way Taxi in Pune",
        link: "/One-Way-Taxi-in-Pune",
    },
    {
        place: "/images/keyword/20.jpg",
        text: "Best Cab service in Pune",
        link: "/Best-Cab-Service-in-Pune",
    },
    {
        place: "/images/keyword/21.jpg",
        text: "Outstation Cabs Pune",
        link: "/Outstation-Cabs-Pune",
    },
    {
        place: "/images/keyword/22.jpg",
        text: "Swift Dzire Hire in Pune",
        link: "/Swift-Dzire-Hire-in-Pune",
    },
    {
        place: "/images/keyword/23.jpg",
        text: "Xcent Hyundai On Rent in Pune",
        link: "/Xcent-Hyundai-On-Rent-in-Pune",
    },
    {
        place: "/images/keyword/24.jpg",
        text: "Nexa Ciaz On Rent in Pune",
        link: "/Nexa-Ciaz-On-Rent-in-Pune",
    },
    {
        place: "/images/keyword/25.jpg",
        text: "Honda City On Rent In Pune",
        link: "/Honda-City-On-Rent-In-Pune",
    },
    {
        place: "/images/keyword/26.jpg",
        text: "Ertiga On Rent in Pune",
        link: "/Ertiga-On-Rent-in-Pune",
    },
    {
        place: "/images/keyword/27.jpg",
        text: "Innova Cab for Outstation in Pune",
        link: "/Innova-Cab-for-Outstation-in-Pune",
    },
];

  
const images = [
    { src: "/images/ourfleet/1.webp", alt: "Image 1" },
    { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

];


const schemaData = {
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  "name": "SHREE Tours & Travels",
  "description": "Book a comfortable and reliable Cab from Pune to Mumbai with SHREE Tours & Travels. Enjoy affordable fares, one-way and round-trip options. Call +91 9594917913 for booking!",
  "address": {
    "@type": "PostalAddress",
    "streetAddress": "Your office address here",
    "addressLocality": "Pune",
    "addressRegion": "Maharashtra",
    "postalCode": "411001",
    "addressCountry": "IN"
  },
  "telephone": "+91-9594917913",
  "url": "https://shreetoursandtravels.in",
  "logo": "https://shreetoursandtravels.in/img/logo.jpg",
  "image": [
    "https://shreetoursandtravels.in/img/pune-to-mumbai-cab.jpg",
    "https://shreetoursandtravels.in/img/mumbai-tour-cab.jpg"
  ],
  "priceRange": "₹1500 - ₹4000",
  "offers": {
    "@type": "Offer",
    "url": "https://shreetoursandtravels.in/pune-to-mumbai-cab-service",
    "priceCurrency": "INR",
    "price": 2000,
    "priceValidUntil": "2025-12-31"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": 4.7,
    "reviewCount": 2200
  },
  "review": [
    {
      "@type": "Review",
      "author": {
        "@type": "Person",
        "name": "Vishal Gupta"
      },
      "datePublished": "2024-08-15",
      "reviewBody": "Fantastic experience! The trip from Pune to Mumbai was smooth and the driver was very friendly. Definitely recommended!"
    },
    {
      "@type": "Review",
      "author": {
        "@type": "Person",
        "name": "Priya Deshmukh"
      },
      "datePublished": "2024-09-10",
      "reviewBody": "The service was great! The Cab was comfortable and on time. I will definitely use SHREE Tours & Travels for future trips to Mumbai."
    }
  ],
  "serviceArea": {
    "@type": "Place",
    "name": "Pune to Mumbai Cab Service",
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": 18.5204,
      "longitude": 73.8567
    }
  },
  "availableChannel": {
    "@type": "ServiceChannel",
    "serviceUrl": "https://shreetoursandtravels.in/pune-to-mumbai-cab-service"
  },
  "keywords": "Pune to Mumbai Taxi, Pune to Mumbai Cab Booking, Pune to Mumbai One-Way Cab, Pune to Mumbai Round Trip Taxi, Affordable Pune to Mumbai Cab, Luxury Pune to Mumbai Cab Service, Private Cab for Mumbai from Pune, Mumbai Travel from Pune by Cab, Group Travel to Mumbai by Cab, Book Pune to Mumbai Car, Pune to Mumbai Cab Rental, Pune to Mumbai Budget Taxi, Pune to Mumbai Family Cab, Book Pune to Mumbai Comfort Cab, Mumbai Sightseeing by Cab, Pune to Mumbai Weekend Trip, Affordable Mumbai Cab Service, Private Mumbai Travel Cab"
};




  return (
    <div>
      <GoogleAnalytics/>
    <Helmet>
  <title>Pune to Mumbai Cab Service | SHREE Tours & Travels | Call: +91 9594917913</title>
  <meta name="description" content="Book a comfortable and reliable Cab from Pune to Mumbai with SHREE Tours & Travels. Enjoy affordable fares, one-way and round-trip options. Call +91 9594917913 for booking!" />
  <meta name="keywords" content="Pune to Mumbai Taxi, Pune to Mumbai Cab Booking, Pune to Mumbai One-Way Cab, Pune to Mumbai Round Trip Taxi, Affordable Pune to Mumbai Cab, Luxury Pune to Mumbai Cab Service, Private Cab for Mumbai from Pune, Mumbai Travel from Pune by Cab, Group Travel to Mumbai by Cab, Book Pune to Mumbai Car, Pune to Mumbai Cab Rental, Pune to Mumbai Budget Taxi, Pune to Mumbai Family Cab, Book Pune to Mumbai Comfort Cab, Mumbai Sightseeing by Cab, Pune to Mumbai Weekend Trip, Affordable Mumbai Cab Service, Private Mumbai Travel Cab" />
  <meta name="robots" content="index, follow" />
  <script type="application/ld+json">
    {JSON.stringify(schemaData)}
  </script>
</Helmet>

    <section
        className="page-title"
        style={{ backgroundImage: 'url(images/hero.jpg)' }}
      >
        <div className="auto-container">
          <div className="title-outer text-center">
            <h1 className="title">{cardData.keyword} </h1>
          </div>
        </div>
      </section>


      <section>
        <div className="container-fluid" >
         <div className="row container-fluid pt-5">
            <div className="col-12 col-md-7 ">
              <img src='/images/keyword/2.jpg' alt='img' />
              <h3 className="py-1 pt-4"
                style={{
                  color: '#0310a8', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3>

              <div className='pb-3'>
                <button
                  className="p-3 text-white fw-bold borderrr bg-header"
                  onClick={() => {
                    window.location.href = '/booking';
                  }}
                >
                  Book Your Cab
                </button>
              </div>
              <p className='fw-bold lead text-dark'>{cardData.headingDescription}</p>
              <div className="">
                <p className='fw-bold py-3 text-dark'>{cardData.top}</p>
                {cardData.topPlaces.map((place, index) => (
                  <div key={index} className="">
                    <div
                      style={{
                        cursor: 'pointer',
                        padding: '10px',
                        marginBottom: '7px',
                        borderRadius: '8px', // Optional: rounded corners
                        transition: 'transform 0.2s' // Optional: smooth scaling effect
                      }}
                    // Centers text within the card
                    >
                      <h4 className="mb-1 darkcolor">{place.title}</h4>
                      <p className="mb-0">{place.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  marginBottom: '7px',
                  borderRadius: '8px', // Optional: rounded corners
                  transition: 'transform 0.2s' // Optional: smooth scaling effect
                }}
              >
                {cardData.services.map((service, index) => (
                  <div key={index} className=" my-4">
                    <h4 className="py-1 darkcolor">{service.name}</h4>
                    <p>{service.description}</p>
                  </div>
                ))}
              </div>

              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
            <BusRatesTable />

              <div id="why-choose-section"
                className='px-2'>
                {cardData.whychoose.map((item, index) => (
                  <div key={index}>
                    <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                    <p>{item.WhyChoosedescription}</p>
                  </div>
                ))}
              </div>
              <div>
                <h3 className='Colo'>FAQs {cardData.keyword} for SHREE Tours & Travels </h3>
                <Accordion data={faqData} />
              </div>
              <div className='py-3'>
                {/* <CustomCarousel items={carouselItems} options={carouselOptions} /> */}

                <TestimonialKeyword testimonials={testimonialsData} />

                
              </div>

              <div className='pb-5'>

                <div className="contact-box Borderr ">
                  <h3>{contactData.heading}</h3>
                  <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                  <div className="contact-details ">
                    <ul>
                      {contactData.contactNumbers.map((number, index) => (
                        <li key={index}>
                          <a href={`tel:${number}`} className="contact-link fw-bold d-inline "><p className='d-inline'><strong className='darkcolor d-inline'>Mobile No:</strong></p>
                            {number}
                          </a>
                        </li>
                      ))}
                    </ul>
                    <p><strong className='darkcolor'>Email Id: </strong>
                      <a href={`mailto:${contactData.email}`} className="contact-link">
                        {contactData.email}
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className='col-12 col-md-4'>
    {Images.map((e) => {
        return (
            <div className="box1">
                <a href={e.link} className="d-flex justify-content-around align-items-center">
                    <div className="b1">
                        <img src={e.place} alt="img" />
                    </div>
                    <div className="b2">
                        <a href={e.link} className='px-3'>{e.text}</a>
                    </div>
                </a>
            </div>
        );
    })}



              <div className="gallery-container">
                <h2 className="gallery-title darkcolor">Our Fleet</h2>
                <div className="row">
                  {images.map((image, index) => (
                    <div className="gallery-item col-md-4" key={index}>
                      <img
                        src={image.src}
                        alt={image.alt}
                        className="gallery-image"

                      />
                    </div>
                  ))}
               
                </div>
              </div>

             <div className=" rounded p-4 shadow-sm Uni_border"
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  border: '3px solid #0310a8',
                  marginBottom: '7px',
                  fontWeight: 'bold',
                }}

              >
                <h4 className="pb-3 pt-3  fw-bold text-bluee text-center">Contact Information</h4>

                <div className="row">

                  <div className="col-12 mb-3 rounded">
                    <div className="Small_border rounded  text-center  " style={{ backgroundColor: '#0310a8' }}>
                      <div>
                      <h4 className=" lead fw-semibold whitt ">Phone Numbers</h4>
                      </div>
                      
                      <div className=''>
                        <a href="tel:+919594917913" className="d-block  text-white">
                        <i className="fas fa-phone darkcolorrr colored me-2"></i>+91 9594917913
                      </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border rounded text-center">
                      
                      <div className='rounded ' style={{ backgroundColor: '#0310a8' }}>
                        <h4 className=" fw-semibold lead whitt">Email</h4>
                        <a href="mailto:booking@shreecabs24.com" className=" text-white d-block">
                        <i className="fas fa-envelope darkcolorrr"></i> booking@shreecabs24.com
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center">
                      
                      <div className='rounded ' style={{ backgroundColor: '#0310a8' }}>
                        <h4 className=" fw-semibold lead whitt">Address</h4>
                        <p className=" text-white ">
                        <i className="fas fa-map-marker-alt darkcolorrr"></i>  SHREE Tours & Travels<br />
                          Maharashtra Co-Operative Housing Society,
                          Yerawada, Pune, Maharashtra India - 411006
                            
                         
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>



            </div>
          </div>
        </div>
      </section>






    </div>
  );
}

export default Punetomumbaicab;